import React, { FC } from 'react'
import { ObjectActionType } from './ObjectActionModal'
import { Warning } from '@mui/icons-material'
import { Button, Dialog } from '../../ui'
import FileFormatIcon from '../../common/FileFormatIcon'

interface ObjectActionConflictModalProps {
	isOpen: boolean
	onClose: () => void
	onAction: (items: any[]) => void
	actionType: ObjectActionType
	conflictedObjects: any[]
}

const ObjectActionConflictModal: FC<ObjectActionConflictModalProps> = ({
	isOpen,
	onClose,
	actionType,
	conflictedObjects,
	onAction,
}) => {
	const operationName = actionType === 'copy' ? 'copy' : 'move'

	return (
		<Dialog
			isOpen={isOpen}
			onClose={onClose}
			title={'File Already Exists'}
			icon={<Warning className="fill-accent" />}
			overlayClassName="bg-opacity-20"
			className="w-[580px]"
			controllers={
				<div className="flex items-center justify-end gap-2">
					<Button
						onClick={onClose}
						label="OK"
						tooltip="Close this dialog"
						classNameWrapper="w-[130px]"
					/>
				</div>
			}
		>
			<p className="text-text-secondary text-base mb-4">
				{conflictedObjects.length === 1
					? `A file with the name "${conflictedObjects[0]?.name}" already exists in the destination folder. The ${operationName} operation cannot be completed.`
					: `${conflictedObjects.length} files already exist in the destination folder. The ${operationName} operation cannot be completed.`}
			</p>
			<div className="max-h-[200px] border border-stroke-dark w-full min-h-10 rounded-lg overflow-auto">
				{conflictedObjects?.map((object) => {
					return (
						<div className="flex items-center gap-2 justify-start py-0.5 h-10 px-2 border-b border-stroke-light last:border-0">
							<FileFormatIcon extension={object?.fileType} />
							<p>{object?.name}</p>
						</div>
					)
				})}
			</div>
		</Dialog>
	)
}

export default ObjectActionConflictModal
